const messages: {
  [key: string]: string;
} = {
  ANALYZING: "Analyzing your profile...",
  USER_WELCOME_MESSAGE:
    "Hi {{name}}, Let's get started by choosing a job opening.",

  JOB_NOT_APPLIED: "Interested in this position? Apply now to get started!",

  CV_NOT_UPLOADED: "Please upload your resume to proceed.",
  WAITING_FOR_MATCH_RESULTS:
    "Hold on! We're checking how well your profile matches this job's requirements...",
  MATCH_RESULT_UNQUALIFIED:
    "Thank you for applying. Our team will assess your profile and get back to you soon.",
  GENERATING_QUESTIONNAIRE:
    "Almost there! We're preparing a few questions to get to know you better...",
  WAITING_FOR_INTERVIEW_SESSION_CREATION:
    "Setting up your interview—just a moment!",
  WAITING_FOR_EVALUATION_RESULT:
    "Reviewing your responses—this won’t take long!",
  EVALUATION_UNQUALIFIED:
    "Thank you for completing the online assessment. Our team will assess your profile and get back to you soon.",
  EVALUATION_QUALIFIED:
    "Congratulations! You have successfully completed the assessment. Our team will reach out to you for the next steps.",
  WAITING_FOR_INTERVIEW_SCHEDULE:
    "Please select an interview slot for an online meeting with our team.",
  INTERVIEW_SCHEDULED_UPCOMING:
    "Your interview with our team is scheduled for {{interview_slot}}",
  WAITING_FOR_FINAL_RESULT:
    "We are evaluating your application, please check again later for the final result...",
  FINAL_RESULT_QUALIFIED:
    "Congratulations! You have qualified for this job, our team will connect with you shortly...",
  FINAL_RESULT_UNQUALIFIED:
    "Thank you for applying. Our team will assess your profile and get back to you soon.",
  INTERVIEW_SCHEDULING_PENDING:
    "🎉 Congrats! You've cleared the online assessment. Please check your email for the next steps.",
  INTERVIEW_QUESTIONS_GENERATION:
    "Almost there! We're preparing a few questions to get to know you better...",
  WAITING_FOR_INTERVIEW_ROUND_COMPLETION:
    "Answer the questions on {{roundName}} to proceed.",
  PREPARING_NEXT_ROUND: "Setting up your interview—just a moment!",
  ALL_ROUND_CLEARED:
    "Thank you for applying, our team will reach out to you soon.",
  UNKNOWN_CONDITION:
    "Oops! Something went wrong on our end. Please try again in a moment, or reach out to support if the issue persists.",
};

export default messages;
